import { MapModel } from '../../../models/MapModel'

export const ZoneMapModel = MapModel.named('ZoneMap')
